// message.js


export const message = {
	state: {
		dataArray: localStorage.getItem("dataArray") != null ? JSON.parse(localStorage.getItem("dataArray")) : []
	},
	mutations: {
		addData(state, data) {
			// 检查是否已存在相同消息（根据消息ID或path+datas组合去重）
			const isDuplicate = state.dataArray.some(item => {
				// 如果有唯一标识id，用id判断
				if (data.id && item.id) {
					return item.id === data.id;
				}
				// 否则用 path + title + content 组合判断
				const itemPath = item.data && item.data.path ? item.data.path : (item.path || '');
				const dataPath = data.data && data.data.path ? data.data.path : (data.path || '');
				const itemTitle = item.title || (item.data && item.data.datas ? item.data.datas.title : '') || '';
				const dataTitle = data.title || (data.data && data.data.datas ? data.data.datas.title : '') || '';
				return itemPath === dataPath && itemTitle === dataTitle;
			});
			
			if (isDuplicate) {
				console.log('消息已存在，跳过重复添加:', data);
				return;
			}
			
			//新增数据放在前面
			state.dataArray.unshift(data);
		},
		deleteData(state, index) {
			state.dataArray.splice(index, 1);
			console.log(state.dataArray)
		},
		updateData(state, {index, newData}) {
			state.dataArray[index] = newData;
		}
	},
	actions: {
		addAndPersist({commit, state}, data) {
			commit("addData", data);
			localStorage.setItem("dataArray", JSON.stringify(state.dataArray));
		},
		deleteAndPersist({commit, state}, index) {
			commit("deleteData", index);
			localStorage.setItem("dataArray", JSON.stringify(state.dataArray));
		},
		updateAndPersist({commit, state}, {index, newData}) {
			commit("updateData", {index, newData});
			localStorage.setItem("dataArray", JSON.stringify(state.dataArray));
		}
	},
	getters: {
		getDataArray: state => {
			return state.dataArray;
		}

	}
}
